import { render, staticRenderFns } from "./VacancyForCallDialog.vue?vue&type=template&id=06cbf36d&scoped=true"
import script from "./VacancyForCallDialog.vue?vue&type=script&lang=js"
export * from "./VacancyForCallDialog.vue?vue&type=script&lang=js"
import style0 from "./VacancyForCallDialog.vue?vue&type=style&index=0&id=06cbf36d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cbf36d",
  null
  
)

export default component.exports